Ember.Application.initializer
  name: 'leafletAssets'

  initialize: (container, application) ->
    L.Icon.Default.imagePath = 'assets/images'
